import { AppState } from '@fcom/core/interfaces/app-state.interface';

import { DestinationSearchState } from './destination-search-filter.interface';

export const DESTINATION_SEARCH_FILTER_STATE_FEATURE_NAME = 'destination-search';

export interface DestinationSearchFeatureState extends AppState {
  [DESTINATION_SEARCH_FILTER_STATE_FEATURE_NAME]: DestinationSearchState;
}
